import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import ReasonModal from "../ReasonModal";
import {
  AddCircle,
  ArrowForwardSquare,
  ArrowRotateRight,
  CloseCircle,
  DocumentDownload,
  Edit2,
  Eye,
  TickCircle,
  Trash,
} from "iconsax-react";
import * as XLSX from "xlsx";
import CustomPagination from "../../Utils/CustomPagination";
import { useLoader } from "../../Loader";
import LogModal from "./LogModal";
import RejectModal from "./RejectModal";

function List(props) {
  const [assetsList, setassetsList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const { startLoader, stopLoader } = useLoader();
  const [showLogModal, setShowLogModal] = useState(false);
  const [currentLog, setCurrentLogs] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "Add",
    };
    props.onChange(propdata);
  };

  const permissions = [
    {
      approve: "cer.HOD_approve",
      reject: "cer.HOD_reject",
      titleA: "HOD Approval",
      titleR: "HOD Reject",
      status: "1",
    },
    {
      approve: "cer.CEO_approve",
      reject: "cer.CEO_reject",
      titleA: "CEO Approval",
      titleR: "CEO Reject",
      status: "2",
    },
    {
      approve: "cer.CFO_approve",
      reject: "cer.CFO_reject",
      titleA: "CFO Approval",
      titleR: "CFO Reject",
      status: "3",
    },
    {
      approve: "cer.Finance_approve",
      reject: "cer.Finance_reject",
      titleA: "Finance Approval",
      titleR: "Finance Reject",
      status: "4",
    },
  ];

  const renderPermissionButtons = (row) =>
    permissions
      .filter((perm) => perm.status == row.status)
      .map((perm, index) => (
        <React.Fragment key={index}>
          {utils.hasPermission(primaryMenuRes, "CER", perm.approve) && (
            <RB.Button
              className="btn-flat me-1"
              title={`${perm.titleA}`}
              onClick={handleApprove(row)}
            >
              <TickCircle />
            </RB.Button>
          )}
          {utils.hasPermission(primaryMenuRes, "CER", perm.reject) && (
            <RB.Button
              className="btn-flat me-1"
              title={`${perm.titleR}`}
              onClick={handleReject(row)}
            >
              <CloseCircle />
            </RB.Button>
          )}
        </React.Fragment>
      ));

  const columns = [
    {
      name: (
        <div>
          Equipment Name <br />
        </div>
      ),
      selector: (row, index) => row.equipment_name,
    },
    {
      name: (
        <div>
          Equipment No. <br />
        </div>
      ),
      selector: (row, index) => row.equipment_no,
    },
    {
      name: "Assets No.",
      selector: (row, index) => row.asset_code_no,
    },
    {
      name: "Assets tag No.",
      selector: (row, index) => row.asset_tag_no,
    },
    // {
    //   name: (
    //     <div>
    //       Assets Logs <br />
    //     </div>
    //   ),
    //   cell: (row) => (
    //     <>
    //       <RB.Button
    //         className="btn-flat me-1"
    //         title="View"
    //         onClick={handleLogView(row)}
    //       >
    //         <Eye />
    //       </RB.Button>
    //     </>
    //   ),
    // },
    {
      name: "Plant Name",
      selector: (row, index) => row?.current_assets.plant_name,
    },
    {
      name: "Location",
      selector: (row, index) => row?.current_assets.location_name,
    },
    // {
    //   name: "Status",
    //   selector: (row, index) => row.status_label,
    // },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          {/* <RB.Button
            className="btn-flat me-1"
            title="Delete"
            onClick={handleView(row)}
          >
            <Eye />
          </RB.Button> */}
          {utils.hasPermission(
            primaryMenuRes,
            "Assets",
            "assets.move_order"
          ) && (
            <>
              {row?.move_order_status == 0 && (
                <>
                  {row?.all_current_assets?.length !== 0 && (
                    <RB.Button
                      className="btn-flat me-1"
                      title="Move Order"
                      onClick={handelAssets(row)}
                    >
                      <ArrowForwardSquare />
                    </RB.Button>
                  )}
                </>
              )}
            </>
          )}
          {/* {utils.hasPermission(primaryMenuRes, "Assets", "assets.edit") && (
            <>
              {row?.status == "1" && (
                <RB.Button
                  className="btn-flat ms-1"
                  title="Edit"
                  onClick={handelEdit(row)}
                >
                  <Edit2 />
                </RB.Button>
              )}
            </>
          )} */}
          {/* {utils.hasPermission(primaryMenuRes, "Assets", "assets.delete") && (
            <>
              {row?.status == "1" && (
                <RB.Button
                  className="btn-flat ms-1"
                  title="Delete"
                  onClick={showDelete(row)}
                >
                  <Trash />
                </RB.Button>
              )}
            </>
          )} */}
          {/* {renderPermissionButtons(row)} */}
          {utils.hasPermission(
            primaryMenuRes,
            "Assets",
            "assets.assets_history"
          ) && (
            <RB.Button
              className="btn-flat ms-1"
              title="View Assets History"
              onClick={handleHistory(row)}
            >
              <ArrowRotateRight />
            </RB.Button>
          )}
        </>
      ),
    },
  ];

  const handleHistory = useCallback((row) => async () => {
    const propdata = {
      mode: "history",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleLogView = useCallback((row) => async () => {
    setCurrentLogs(row.cer_log);
    setShowLogModal(true);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleReject = useCallback((row) => async () => {
    setSelectedOrder(row);
    setShowRejectModal(true);
  });

  useEffect(() => {
    getassetsList();
  }, [page]);

  const getassetsList = () => {
    startLoader();
    utils
      .callAPI("get", `assets/list?page=${page}&per_page=${countPerPage}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setassetsList(res);
          stopLoader();
          // setFilter(false)
        } else {
          setassetsList([]);
          stopLoader();
        }
      })
      .catch((err) => {
        setassetsList([]);
        stopLoader();
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handelAssets = useCallback((row) => async () => {
    const propdata = {
      mode: "Add",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/cer/delete?id=${row?.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getassetsList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleApprove = useCallback((row) => async () => {
    startLoader();
    var bodyFormData = new FormData();
    bodyFormData.append("cer_id", row.id);
    bodyFormData.append("status", "accept");
    bodyFormData.append("reject_reason", "");

    utils
      .callAPI("post", `/cer/change-status`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          getassetsList();
          stopLoader();
        } else {
          getassetsList();
          stopLoader();
        }
      })
      .catch((err) => {
        getassetsList();
        stopLoader();
      });
  });

  const handleDownload = () => {
  startLoader(); // show loader during download

  utils
    .callAPI("get", `assets/list?page=0&per_page=0`)
    .then((res) => {
      stopLoader();

      // if (res && Array.isArray(res.result) && res.result.length > 0) {
        // ✅ Exact CSV header as requested
        const csvHeader = `Sr.No.,Equipment Name,Equipment No.,Asset No.,Asset Tag No.,Plant Name,Location`;

        // ✅ Map through rows and create CSV lines
        const csvRows = res.result.map((item, index) => {
          const currentAssets = item?.current_assets || {};
          return [
            index + 1,
            `"${item.equipment_name || ""}"`,
            `"${item.equipment_no || ""}"`,
            `"${item.asset_code_no || ""}"`,
            `"${item.asset_tag_no || ""}"`,
            `"${currentAssets.plant_name || ""}"`,
            `"${currentAssets.location_name || ""}"`,
          ].join(",");
        });

        // ✅ Combine all lines
        const csvContent = [csvHeader, ...csvRows].join("\n");

        // ✅ Trigger file download
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");

        

        link.href = URL.createObjectURL(blob);
        link.download = `Assets_List_.csv`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      // } 
    })
    .catch((err) => {
      
    });
};

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow ">
          <div className="floating-btns-holder-artisan">
            {/* {utils.hasPermission(primaryMenuRes, "Assets", "assets.create") && ( */}
            <a
              href
              className={`${
                assetsList.result?.length == 0 ? "disabled" : ""
              } btn btn-primary btn-circle me-2`}
              variant="primary"
              onClick={() => handleDownload()}
            >
              <DocumentDownload />
            </a>
            {/* )} */}
          </div>
          <RB.Card.Header>
            <h4></h4>
            <div className="card-header-action"></div>
          </RB.Card.Header>
          <RB.Card.Body>
            {utils.hasPermission(primaryMenuRes, "Assets", "assets.view") && (
              <>
                <DataTable
                  columns={columns}
                  data={assetsList.result}
                  highlightOnHover
                  responsive
                  pagination
                  paginationServer
                  paginationTotalRows={assetsList.total}
                  paginationPerPage={countPerPage}
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                  }}
                  paginationComponent={() => (
                    <CustomPagination
                      currentPage={page}
                      totalRows={assetsList.total}
                      rowsPerPage={countPerPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                  striped
                  onChangePage={(page) => setPage(page)}
                  persistTableHead
                  customStyles={{
                    head: {
                      style: {
                        fontSize: "0.875rem", // Adjust the font size as needed
                        fontWeight: "bold", // Adjust the font weight as needed
                      },
                    },
                  }}
                  // subHeader
                  // subHeaderComponent={subHeaderComponent}
                />
              </>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
      <LogModal
        show={showLogModal}
        onHide={() => setShowLogModal(false)}
        logs={currentLog}
      />
      <RejectModal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        onReject={handleReject}
        selectedOrder={selectedOrder}
        getPurchaseOrder={getassetsList}
      />
    </>
  );
}

export default List;
